// extracted by mini-css-extract-plugin
export var active = "_bt-7";
export var blink = "_bt-8";
export var dropDownSelector = "_bt-4";
export var dropDownWrapper = "_bt-3";
export var fakeCursor = "_bt-6";
export var fontSizeButton = "_bt-9";
export var formQuillEditor = "_bt-0";
export var pressed = "_bt-a";
export var qlBlank = "_bt-1";
export var textFormattingToolbar = "_bt-2";
export var textToolbarOption = "_bt-5";